
  
<script>
import Layout from "../../layouts/main";
import CampaignApi from "@/services/campaign-api";

export default {
    name: 'delivery-etat',
    components: {Layout},

    props:{
     campaignId :{
            type:Number,
            default: null
        },
    },
    data() {
      return {
        pagemodel: {currentPage : 1, perPage :16, totalRows: 0},
        status:null,
        planningDeliveryBagsList:null,
        detalisDeliveryBags:null,
        isTableLoading:false,
        eventsDeliveryBag:null,
        showModalDelaisEvent: false,


      };
    },

    mounted() {
        this.getPlanningDeliveryBagsList()
    },

    watch:{
        status:function(){
            this.pagemodel= {currentPage : 1, perPage :16, totalRows: 0},
            this.getPlanningDeliveryBagsList()
        }
    },

    methods: {

        filterByStatus(eventType){
        if(this.status == eventType){
            this.status = null
        }   else{
            this.status = eventType
        }
        },
        
        eventToColor(lastEvent){
            switch(lastEvent){
            case 0: return '#137437';
            case 1:return '#f1b44c';
            case 2 :return '#505971';
            case 3 :return '#d11010';
            default: return '_'
            }
        },

        eventToImage(lastEvent){
            switch(lastEvent){
            case 0: return 'delivered-box-verification';
            case 1:return 'delivery-truck-time';
            case 2 :return 'calendar-add';
            case 3 :return 'delivery-truck-error';
            default: return '_'
            }
        },

        lastEventToColor(lastEvent){
            switch(lastEvent){
            case 0: return 'success font-weight-bold';
            case 1:return 'warning font-weight-bold';
            case 2 :return 'light font-weight-bold';
            case 3 :return 'danger font-weight-bold';
            default: return '_'
            }
        },

        lastEventToLabel(lastEvent){
            switch(lastEvent){
                case 0: return 'Livrée';
                case 1:return 'En cours';
                case 2 :return 'Planifiée';
                case 3 :return 'Anomalie';
                default: return '_'
            }
    },

        openModalDelaisEvent(id){
            this.eventsDeliveryBag = null
            this.getEventsDeliveryBagByPosBarCode(id)
            this.showModalDelaisEvent = true;
        },

        getEventsDeliveryBagByPosBarCode(id){
            CampaignApi.getEventsDeliveryBagByPosBarCode(id).then(result=>{
                this.eventsDeliveryBag = result 
            })

        },

        downloadShipoxAwb(deliveryPlanningBagsId) {
            CampaignApi.downloadFParcelAwb(deliveryPlanningBagsId )
            .then((awbUrl) => {
                if (awbUrl) {
                    window.open(awbUrl, "_self"); 
                }
                })
            },

        getPlanningDeliveryBagsList(){
            this.isTableLoading = true
            CampaignApi.getPlanningDeliveryBagsList(this.pagemodel.currentPage, this.pagemodel.perPage, this.campaignId, this.status).then(result=>{
                if(result && result.detailsDeliveryBag){

                    const detailsDeliveryBagPage = result.detailsDeliveryBag ;

                    this.detalisDeliveryBags=result;
                    this.planningDeliveryBagsList=detailsDeliveryBagPage.list;

                    this.pagemodel.totalRows = detailsDeliveryBagPage.total;
                    this.pagemodel.currentPage = detailsDeliveryBagPage.page;
                    this.pagemodel.perPage = detailsDeliveryBagPage.pageSize;
                    this.pagemodel.pageSize = detailsDeliveryBagPage.pageSize;

                    this.isTableLoading = false


                }
            })
        }

    },
  };
  </script>

<template>
    <Layout>

        <div class="pr-sm-5 pl-sm-5">

            <div v-if="detalisDeliveryBags" class=" border-0 rounded-3  mr-sm-4 ml-sm-4 mb-4">
                <div class="p-3 ">
                    <div class="row">
                        <div class="col-xl-3 ">
                            <h1 class="text-primary text-uppercase font-weight-bold">{{ detalisDeliveryBags.campaignName	 }}
                                <!-- <span class="font-size-12 text-dark">( {{ detalisDeliveryBags.quantityOrderedBags}} {{ $t('campaign.bags') }} )</span> -->
                            </h1>
                            <h2 class="text-dark mt-2">{{ detalisDeliveryBags.quantityOrderedBags}} {{ $t('campaign.bags') }}</h2>
                            <h6 class="text-dark mt-3   ">{{ $t('campaign.delivery.updatedDate') }}  : {{ detalisDeliveryBags.timeStamp}}</h6>
                        </div>

                        <div v-if="detalisDeliveryBags && detalisDeliveryBags.statusDeliveryBag	" class="col-xl-9"  >
                            <div class="row font-size-14 font-weight-bold">
                                <div v-for="statusDeliveryBag in detalisDeliveryBags.statusDeliveryBag" :key="statusDeliveryBag.eventType" class="col-lg-3 col-md-3 col-sm-6  col-12 " >

                                   <div class="text-center mr-5 ml-5" 
                                     @click="filterByStatus(statusDeliveryBag.eventType)"
                                            :style="{ 
                                            cursor: 'pointer', 
                                            border: status === statusDeliveryBag.eventType ? `2px solid ${eventToColor(statusDeliveryBag.eventType)}` : 'none', 
                                            borderRadius: '5px', 
                                            padding: '5px'
                                            }">
                                        <div class="text-uppercase" style="cursor: pointer;" :style="{ color: eventToColor(statusDeliveryBag.eventType) }" >
                                            <span>
                                            <img alt="state" width="20px" class="mr-2" :src="require(`@/assets/icons/${eventToImage(statusDeliveryBag.eventType)}.svg`)" style="cursor: pointer;" />
                                            </span>
                                            {{ lastEventToLabel(statusDeliveryBag.eventType)}}
                                        </div>

                                        <div class="mt-1">
                                            <div class="text-uppercase font-size-16">
                                                {{ statusDeliveryBag.totalQuantityBags}}  {{ $t('campaign.bags') }} 
                                            </div>

                                            <div class="text-dark"> 
                                                <small>
                                                    ( <strong class="font-size-16 mr-1">{{ statusDeliveryBag.count}}</strong> {{ $t('campaign.delivery.deliveryList') }} )
                                                </small>
                                            </div>

                                        </div>
                                   </div>
                     

                                </div>
                            </div>

                        </div>


                    </div>

                    

                </div>
            
            </div>

            <div v-if="this.planningDeliveryBagsList "  class=" p-sm-2">
                <div class="row">
                    <div v-for="planningDeliveryBag in this.planningDeliveryBagsList"   :key="planningDeliveryBag.id"   class="col-md-4 col-lg-3 col-sm-6 col-12 p-sm-4 p-0 mt-sm-0 mt-3" >
                        <div class="card shadow-sm rounded-3 h-100" style="border: 1px solid rgb(221, 221, 221);">
                            <div class="card-header      rounded-top pr-2 pt-2 pb-0 pl-3" style="background:white !important;">
                                

                                <div>
                                    <b-badge href="#" :variant="lastEventToColor(planningDeliveryBag.lastEvent)" class="float-right font-size-12">
                                        {{lastEventToLabel(planningDeliveryBag.lastEvent)}}
                                    </b-badge>
                                </div>

                              


                                <div class="d-flex align-items-center">
                                    <h5 class="mb-0  text-primary font-weight-bold text-uppercase"
                                    >{{ planningDeliveryBag.partnerName }}</h5>                            
                                </div>
                                <div class="mb-0 mt-1 font-size-10 text-dark">


                                <div class="d-flex text-primary align-items-start mb-1">
                                        
                                        <img alt="delivery-date" width="18px" src="@/assets/icons/delivery-date.svg" class="" />
                                        <div class="">
                                            <strong class="ml-1">{{ planningDeliveryBag.deliveryDate }}</strong>
                                        </div>

                                        <span class="mr-1 ml-1">|</span>

                                        <img alt="bag" width="20px" src="@/assets/icons/bag.svg" class="mr-0" />
                                        <strong class="ml-1 text-uppercase">{{ planningDeliveryBag.quantityBags }} </strong>

                                        <span class="mr-1 ml-1">|</span>

                                        <span class="ml-1">{{ planningDeliveryBag.partnerCountry }}, {{ planningDeliveryBag.partnerCity }}</span>


                                </div>

                               


                                </div>

                               
                                <hr/>
                                

                            </div>
                            <div class="card-body h-100 pt-0 pb-2" >

                                
                                


                                <div  class="row ">
                                    <div class="col-6 text-left " :class="planningDeliveryBag.posBarCode ? 'text-dark'  : 'text-danger'">
                                        {{$t('campaign.delivery.fparcelNumber')}} 
                                        <div><strong>{{ planningDeliveryBag.posBarCode ? planningDeliveryBag.posBarCode : '_' }}</strong>
                                            <span>
                                            <img v-if="planningDeliveryBag.posBarCode" alt="info" class="ml-2" width="17px" src="@/assets/icons/printer.svg" style="cursor: pointer;" @click="downloadShipoxAwb(planningDeliveryBag.id)" />
                                            </span>
                                        </div>
                                    </div>

                                    <div class="col-6 text-right">
                                        <img v-if="planningDeliveryBag.posBarCode" alt="info" class="mr-2" width="25px" src="@/assets/icons/info-circle.svg" style="cursor: pointer;" @click="openModalDelaisEvent(planningDeliveryBag.id)" />
                                    </div>

                                      

                                </div>
                                

                                

                               

                                <div class="d-flex align-items-start mt-2 text-dark">
                                    <div>
                                        
                                        <div  class="mt-1">
                                            {{ $t('campaign.delivery.lastEventDate') }} 
                                            <strong class="ml-1">{{ planningDeliveryBag.lastEventDate?  planningDeliveryBag.lastEventDate : ''}}</strong>

                                        </div>

                                        <div  class="mt-1">
                                            {{ $t('campaign.delivery.updatedDate') }} 
                                            <strong  class="ml-1">{{ planningDeliveryBag.timeStamp ? planningDeliveryBag.timeStamp : '' }}</strong>
                                        </div>
                                       
                                    </div>
                                </div>

                            </div> 
                        </div>
                    </div>
                </div>
                <span v-if="!isTableLoading && planningDeliveryBagsList && !planningDeliveryBagsList.length" class="d-flex justify-content-center m-4 font-size-20 text-uppercase text-danger" >Aucune livraison planifiée pour cette campagne ! </span>
            </div>
                <!-- Pagination -->
                <div v-if="planningDeliveryBagsList && planningDeliveryBagsList.length" class="row pt-3 pl-2 mr-3 ml-3 " >
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="getPlanningDeliveryBagsList()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[12,16,52,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur </span><span class="font-weight-bold"> {{pagemodel.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getPlanningDeliveryBagsList()" :disabled="isTableLoading" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                <!-- Fin Pagination  -->

                <b-modal
                        v-if="eventsDeliveryBag"         
                        v-model="showModalDelaisEvent" 
                        hide-footer
                        hide-header
                        centered
                        title-tag="h5"
                        header-close-variant="danger"
                        title-class="text-warning"
                        size="md">

                        <div class="row p-1">
                            <div class="col-12 text-left">
                                <div class="font-size-20 text-primary text-uppercase font-weight-bold ">{{ eventsDeliveryBag.partnerName }}</div>
                                <div class="text-dark mt-1"> <span class="mr-1"> {{$t('campaign.delivery.barCode')}} </span> <strong>{{ eventsDeliveryBag.posBarCode }} </strong></div>
                            </div>

                        </div>

                     
                <div class="mt-3">
                    <ul class="event-list">

                   
                        <li v-for="(event, index) in this.eventsDeliveryBag.statusJson.POS_EVENT_LIST" 
                            :key="index" 
                            :class="{'special-event': event.EVENTID === 25, 'regular-event': event.EVENTID !== 25}" class="pt-2 pb-2" >
                            <span class="event-date font-size-14 text-secondary">{{ event.evDateStr }}</span>
                            <span class="event-title font-size-14 text-secondary">{{ event.EV_INTITULE }}</span>
                        </li>

                    </ul>
                </div>

                </b-modal>


        </div>


   

    </Layout>
</template>
<style scoped>
.event-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.event-list li {

  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  /*align-items: center;*/
  /*box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);*/
  transition: transform 0.3s, box-shadow 0.3s;
}

.event-list li:hover {
    transition: transform 0.3s ease, color 0.3s ease;
 /* box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);*/
}

.event-title {
  font-weight: normal;
  color: #333;
}

.event-date {
  color: #666;
  font-size: 0.9rem;
}

.special-event {
  background: linear-gradient(135deg, #e6f5eb, #c9e8d4);
  border: 2px solid #a3d2b3; 
  color: #137437 !important; 
  font-weight: bold !important;
}
.special-event .event-title {
  color: #137437;
}

.regular-event {
  /*background-color: #e9ecef;*/
 /* border: 1px solid #dee2e6;*/
}
</style>
